export default class SteppedForm {
  constructor($scope, { onComplete, beforeNext }) {
    this.$scope = $scope;
    this._onComplete = onComplete || (() => {});
    this._beforeNext = beforeNext || (() => { return true });
    this.steps = [...this.$scope.querySelectorAll('.step')];
    this.currentStep = this.$scope.querySelector('.step.active:first-child') || this.steps[0];
    this.bindEvents();
  }

  bindEvents() {
    this.$scope.querySelectorAll('[data-stepped-form="next"]').forEach( ($action) => $action.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.next();
    }));
    this.$scope.querySelectorAll('[data-stepped-form="previous"]').forEach( ($action) => $action.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.previous();
    }));
    this.$scope.querySelectorAll('[data-stepped-form="complete"]').forEach( ($action) => $action.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.onComplete();
    }));
  }

  next() {
    if (this.isLastStep())
      return this.onComplete();

    if (!this._beforeNext(this.currentStep))
      return;

    this.setStep(this.steps[this.currentIndex() + 1]);
  }

  previous() {
    if (this.isFirstStep())
    return;

    this.setStep(this.steps[this.currentIndex() - 1]);
  }

  fromScratch() {
    this.setStep(this.steps[0]);
  }

  setStep(step) {
    this.currentStep.classList.toggle('active', false);
    this.currentStep = step;
    this.currentStep.classList.toggle('active', true);
  }

  onComplete() {
    this._onComplete();
  }

  isLastStep()  {
    return this.currentIndex() == this.steps.length - 1;
  }

  isFirstStep()  {
    return this.currentIndex() == 0;
  }

  currentIndex() {
    return this.steps.indexOf(this.currentStep);
  }
}